import { useState, useEffect, useCallback } from 'react';
import { apiFetch, apiUpload } from '../api/client';

export function useGallery() {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGallery = useCallback(() => {
    setLoading(true);
    apiFetch('/gallery.php')
      .then(data => setPhotos(data))
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchGallery();
  }, [fetchGallery]);

  const uploadPhoto = async (file, caption = '') => {
    const formData = new FormData();
    formData.append('action', 'upload');
    formData.append('file', file);
    formData.append('caption', caption);
    const newPhoto = await apiUpload('/gallery.php', formData);
    setPhotos(prev => [newPhoto, ...prev]);
    return newPhoto;
  };

  const deletePhoto = async (filename) => {
    await apiFetch(`/gallery.php?file=${encodeURIComponent(filename)}`, { method: 'DELETE' });
    setPhotos(prev => prev.filter(p => p.filename !== filename));
  };

  const reorderPhotos = async (newOrder) => {
    setPhotos(newOrder);
    await apiFetch('/gallery.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'reorder', order: newOrder.map(p => p.filename) }),
    });
  };

  return { photos, loading, error, uploadPhoto, deletePhoto, reorderPhotos, refresh: fetchGallery };
}
